import React,  {Component} from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { UPDATE } from 'admin-on-rest';
import restClient from '../restClient';

import { Card, CardText } from 'material-ui/Card';
import { List } from 'material-ui/List';
import { DateField, BooleanField, translate, TextField as TextField2 } from 'admin-on-rest';
import CHUrlField from '../utils/CHUrlField'
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { push as pushAction } from 'react-router-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { withStyles } from 'material-ui/styles';
import { initialize } from 'redux-form';
import RichTextInput from 'aor-rich-text-input';
import CHRichTextInput from '../utils/CHRichTextInput';

//form validations
//allow a-z0-9 and dash (-) and backslash (\\) and forward slash (\/): [a-z0-9\-\\\/]
const website = value => value && !/^(http\:\/\/|https\:\/\/)+([a-z0-9][a-z0-9\-]*\.)+[a-z0-9\-\\\/]*$/i.test(value) ?
  'Ongeldig website adres' : undefined
const required = value => value ? undefined : 'Verplicht'
const maxLength = max => value =>
  value && value.length > max ? `Max length of ${max} characters exceeded` : undefined
const maxLength25 = maxLength(25)

const styles = {};


//see http://redux-form.com/6.4.3/examples/material-ui/
/*hintText={label}*/

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
  <TextField 
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
  />
)

const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    children={children}
    {...custom}/>
)


	
class CustomForm extends Component {
	state = {};
	
	constructor(props){
	    super(props);
		this.props.dispatch(initialize('customForm', this.props.record));
  	}
	
	componentWillMount() {
		//
    }
	
	saveDetails = ({...formdata }) => {
    	const { record, showNotification, push } = this.props;
		
		//get HTML from RTE for description
		formdata.description=document.getElementById("rt-description").getElementsByClassName("ql-editor")[0].innerHTML;
		
		//send updated form data to api
		restClient(UPDATE, 'member/ad_detail', {id: formdata.id, data: formdata} )
		   .then((response) => {
			   //redirect to next step
			   push('/member/ad_plans/'+response.data.id);				
			})
			.catch((e) => {
				console.error(e);
				showNotification('cloudhints.error_try_again','warning')
			});
    }
	
   
   	render() {
	    const { record, translate, handleSubmit} = this.props;
				
       	//record contains all the data which needs to be populated into the fields
		//record = {firstName:'john',lastName:'doe'}
		return (
		
	
			<form onSubmit={handleSubmit(this.saveDetails)}>
				<div className="row form-horizontal form-fullwidth">
					<div className=" col col-35">						
						<h3>Plaatsing details</h3>
						<div className="form-field">
							<Field
							name="link_to_site"
							component={renderTextField}
							type="text"
							label="Link naar uw website / module pagina"			
							validate={[ required, website ]}
							/>
						</div>
						<div className="form-field">
							<Field
							name="link_to_trial"
							component={renderTextField}
							type="text"
							label="Link naar gratis uitproberen pagina"			
							validate={[ required, website ]}
							/>
						</div>
						
						
						
						<div className="form-field">
						
							logo
						</div>
						
						
						
						<div className="form-field ">
							<Field source="show_screens_video" name="show_screens_video" component={renderSelectField} label="Toon video of screenshots op detailpagina?">
							  <MenuItem value={'screenshots'} primaryText="Screenshots"/>
							  <MenuItem value={'video'} primaryText="Video"/>
							</Field>
							
						</div>
						
						<div className="form-field belowSelectField">
							<Field
							name="video_url"
							component={renderTextField}
							type="text"
							label="URL naar Youtube video"			
							validate={[ required ]}
							/>
						</div>
						
						<div className="form-field">
						
							screenshots
						</div>
						
						
						
					</div>
					<div className="col col-25">	
						<h3>Unique selling points</h3>
						<div className="form-field">
							<Field
							name="usp1"
							component={renderTextField}
							type="text"
							label="USP 1"			
							validate={[ required, maxLength25 ]}
							/>
						</div>
						<div className="form-field">
							<Field
							name="usp2"
							component={renderTextField}
							type="text"
							label="USP 2"			
							validate={[ required, maxLength25 ]}
							/>
						</div>
						<div className="form-field">
							<Field
							name="usp3"
							component={renderTextField}
							type="text"
							label="USP 3"			
							validate={[ required, maxLength25 ]}
							/>
						</div>
						<div className="form-field">
							<Field
							name="usp4"
							component={renderTextField}
							type="text"
							label="USP 4"				
							validate={[ required, maxLength25 ]}
							/>
						</div>
					</div>			
				</div>
				<div className="row "><br/></div>
				<div className="row form-horizontal form-fullwidth">
					<h3>Omschrijving detailpagina</h3>					 
					<CHRichTextInput source="description" value={record.description} id="rt-description" />
				</div>
				
				<RaisedButton type="submit" primary label={translate('cloudhints.save_next')} />				
			</form>
		 );
    }
}


CustomForm = reduxForm({
  form: 'customForm' 
})(CustomForm)

CustomForm = connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
}
)(CustomForm)

export default translate(CustomForm)


// WEBPACK FOOTER //
// ./src/ads/AdDetails_Form.js